/*eslint-disable*/
import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import {
  TextField,
  Typography,
  Divider,
  Paper,
  Grid,
  Button,
  Collapse,
  FormControlLabel,
  Radio,
  RadioGroup,
  Box
} from "@mui/material";
import CustomDropDownPicker from "../../../components/CustomDropDownPicker";
import PropertyTypeDropdown from '../../../components/PropertyTypeDropdown';
import { STYLES } from "config";

// Fix: Use forwardRef properly
const BackOfficeStep = forwardRef((props, ref) => {
  const { data, setvalue } = props;
  const [state, setstate] = useState(data);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenTwo, setisOpenTwo] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setstate(data);
  }, [data]);

  const updateData = (e) => {
    const { name, value } = e.target;
    const updatedState = { ...state, [name]: value || null };
    setstate(updatedState);
    setvalue(updatedState);
  };

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    const updatedState = { ...state, [name]: value };
    setstate(updatedState);
    setvalue(updatedState);
  };

  const handleDropdownChange = (name, value) => {
    console.log("handleDropdownChange", { name, value })
    const updatedState = { ...state, [name]: value };
    setstate(updatedState);
    setvalue(updatedState);

    // Clear error on change
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  // Get readable label for error messages
  const getFieldLabel = (fieldName) => {
    const labels = {
      type: "Listing Type",
      p24propertyType: "Property Type",
      industrialCommercial: "Usage Type"
    };
    return labels[fieldName] || fieldName;
  };

  // Dropdown options
  const listingTypeOptions = [
    { value: "both", label: "Both" },
    { value: "tolet", label: "To Let" },
    { value: "sale", label: "For Sale" }
  ];


  const usageTypes = [
    { value: "Commercial", label: "Commercial" },
    { value: "Industrial", label: "Industrial" }
  ];

  // Expose validation to parent stepper
  useImperativeHandle(ref, () => ({
    isValidated() {
      let isValid = true;
      const newErrors = {};

      // Validate required fields
      console.log("Type: ", state.type)
      if (!state.type || state.type === "") {
        newErrors.type = "Listing Type is required";
        isValid = false;
        console.log("listing type")
      }
      console.log('state.p24propertyType', state.p24propertyType)
      if (!state.typeOfProperty || state.typeOfProperty === "") {
        newErrors.typeOfProperty = "Property Type is required";
        isValid = false;
      }
      if (!state.industrialCommercial || state.industrialCommercial === "") {
        newErrors.industrialCommercial = "Usage Type is required";
        isValid = false;
      }

      setErrors(newErrors);
      return isValid;
    }
  }));

  const toggle = () => setIsOpen(!isOpen);
  const toggleTwo = () => setisOpenTwo(!isOpenTwo);

  const inputStyle = {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#003366"
      },
      "&:hover fieldset": {
        borderColor: "#003366"
      }
    },
    "& .MuiInputBase-input": {
      color: STYLES.SECONDARY_APP_CLR
    }
  };

  return (
    <Paper elevation={5} sx={{ p: 3 }}>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 400,
          mb: 1,
          color: STYLES.SECONDARY_APP_CLR
        }}
      >
        Back Office
      </Typography>

      <Divider sx={{ borderColor: "#003366", mb: 2 }} />

      <Paper elevation={0} sx={{ p: 3, mb: 2 }}>
        <Typography variant="body1">
          This page is used to add Back Office details to a listing. This
          information is used by the API Property Group team to manage the
          listing. The information is not visible to the public.
        </Typography>
      </Paper>

      <Divider sx={{ borderColor: "#003366", mb: 2 }} />

      <Grid container spacing={1}>
        {/* Listing ID */}
        {/* <Grid item size={2}>
          <Typography variant="body1" sx={{ fontWeight: 400, mt: 1.5, color: STYLES.SECONDARY_APP_CLR }}>
            Listing ID
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            fullWidth
            name="ListingId"
            size="small"
            value={state?.ListingId || ""}
            onChange={updateData}
            sx={inputStyle}
          />
        </Grid> */}

        {/* Office */}
        <Grid item size={2}>
          <Typography variant="body1" sx={{ fontWeight: 400, mt: 1.5, color: STYLES.SECONDARY_APP_CLR }}>
            Office
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            fullWidth
            name="office"
            size="small"
            value={state?.office || 12}
            onChange={updateData}
            sx={inputStyle}
          />
        </Grid>

        {/* Web Ref. No */}
        <Grid item size={2}>
          <Typography variant="body1" sx={{ fontWeight: 400, mt: 1.5, color: STYLES.SECONDARY_APP_CLR }}>
            Web Ref. No
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            fullWidth
            name="web_Ref_No"
            size="small"
            disabled
            value={state?.web_Ref_No || ""}
            onChange={updateData}
            sx={inputStyle}
          />
        </Grid>

        {/* Listing Type */}
        <Grid item size={2}>
          <Typography variant="body1" sx={{ fontWeight: 400, mt: 1.5, color: STYLES.SECONDARY_APP_CLR }}>
            Listing Type<span style={{ color: "red" }}>*</span>
          </Typography>
        </Grid>
        <Grid item size={10}>
          <CustomDropDownPicker
            required
            options={listingTypeOptions}
            value={state?.type || ""}
            onChange={(value) => handleDropdownChange("type", value)}
            placeholder="Select Listing Type"
            style={{
              borderColor: errors.type ? "red" : "#003366",
              color: STYLES.SECONDARY_APP_CLR
            }}
          />
          {errors.type && (
            <Typography variant="caption" color="error" sx={{ ml: 2 }}>
              {errors.type}
            </Typography>
          )}
        </Grid>

        {/* Property Type */}
        <Grid item size={2}>
          <Typography variant="body1" sx={{ fontWeight: 400, mt: 1.5, color: STYLES.SECONDARY_APP_CLR }}>
            Property Type<span style={{ color: "red" }}>*</span>
          </Typography>
        </Grid>
        <Grid item size={10}>
          <div style={{ width: "100%" }}>
            <PropertyTypeDropdown
              value={data.typeOfProperty}
              onChange={(selectedProperty, p24Value, ppValue) => {
                setvalue({
                  ...state,
                  typeOfProperty: selectedProperty,
                  p24propertyType: p24Value,
                  pppropertyType: ppValue
                });
              }}
            />
          </div>
          {errors.typeOfProperty && (
            <Typography variant="caption" color="error" sx={{ ml: 2 }}>
              {errors.typeOfProperty}
            </Typography>
          )}
        </Grid>

        {/* Usage Type */}
        <Grid item size={2}>
          <Typography variant="body1" sx={{ fontWeight: 400, mt: 1.5, color: STYLES.SECONDARY_APP_CLR }}>
            Usage Type<span style={{ color: "red" }}>*</span>
          </Typography>
        </Grid>
        <Grid item size={10}>
          <CustomDropDownPicker
            required
            options={usageTypes}
            value={state?.industrialCommercial || ""}
            onChange={(value) => handleDropdownChange("industrialCommercial", value)}
            placeholder="Select Usage Type"
            style={{
              borderColor: errors.industrialCommercial ? "red" : "#003366",
              color: STYLES.SECONDARY_APP_CLR
            }}
          />
          {errors.industrialCommercial && (
            <Typography variant="caption" color="error" sx={{ ml: 2 }}>
              {errors.industrialCommercial}
            </Typography>
          )}
        </Grid>

        {/* Tender */}
        <Grid item size={2}>
          <Typography variant="body1" sx={{ fontWeight: 400, mt: 1.5, color: STYLES.SECONDARY_APP_CLR }}>
            Tender
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            fullWidth
            name="tender"
            size="small"
            value={state?.tender || ""}
            onChange={(e) => setvalue({ ...state, tender: e.target.value })}
            sx={inputStyle}
          />
        </Grid>

        {/* Auction */}
        <Grid item size={2}>
          <Typography variant="body1" sx={{ fontWeight: 400, mt: 1.5, color: STYLES.SECONDARY_APP_CLR }}>
            Auction
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            fullWidth
            name="auction"
            size="small"
            value={state?.auction || ""}
            onChange={updateData}
            sx={inputStyle}
          />
        </Grid>

        {/* Lease Details Toggle
        <Grid item size={10}>
          <Button variant="contained" color="primary" onClick={toggleTwo} sx={{ mb: 2 }}>
            {isOpenTwo ? "Hide Lease Details" : "Show Lease Details"}
          </Button>
          <Divider sx={{ borderColor: "#003366", mb: 2 }} />
          <Paper elevation={0} sx={{ p: 2, mb: 2 }}>
            <Typography variant="body1">
              Information should be completed as per the lease agreement
            </Typography>
          </Paper>
          <Divider sx={{ borderColor: "#003366", mb: 2 }} />
        </Grid>

        <Collapse in={isOpenTwo} timeout="auto" unmountOnExit sx={{ width: "100%" }}>
          {/* Lease Fields 
          <Grid container spacing={2}>
            <Grid item size={2}>
              <Typography variant="body1" sx={{ mt: 1.5 }}>
                Bank Repossessed
              </Typography>
            </Grid>
            <Grid item size={10}>
              <RadioGroup
                row
                name="bankRepossessed"
                value={state?.bankRepossessed || ""}
                onChange={handleRadioChange}
              >
                <FormControlLabel value="YES" control={<Radio />} label="YES" />
                <FormControlLabel value="NO" control={<Radio />} label="NO" />
              </RadioGroup>
            </Grid>

            <Grid item size={2}>
              <Typography variant="body1" sx={{ mt: 1.5 }}>
                Distressed
              </Typography>
            </Grid>
            <Grid item size={10}>
              <RadioGroup
                row
                name="distressed"
                value={state?.distressed || ""}
                onChange={handleRadioChange}
              >
                <FormControlLabel value="YES" control={<Radio />} label="YES" />
                <FormControlLabel value="NO" control={<Radio />} label="NO" />
              </RadioGroup>
            </Grid>

            <Grid item size={2}>
              <Typography variant="body1" sx={{ mt: 1.5 }}>
                Sole Mandate
              </Typography>
            </Grid>
            <Grid item size={10}>
              <RadioGroup
                row
                name="soleMandate"
                value={state?.soleMandate || ""}
                onChange={handleRadioChange}
              >
                <FormControlLabel value="YES" control={<Radio />} label="YES" />
                <FormControlLabel value="NO" control={<Radio />} label="NO" />
              </RadioGroup>
            </Grid>

            <Grid item size={2}>
              <Typography variant="body1" sx={{ mt: 1.5 }}>
                Zoning
              </Typography>
            </Grid>
            <Grid item size={10}>
              <TextField
                fullWidth
                name="zoning"
                size="small"
                value={state?.zoning || ""}
                onChange={updateData}
                sx={inputStyle}
              />
            </Grid>

            <Grid item size={2}>
              <Typography variant="body1" sx={{ mt: 1.5 }}>
                Lease Period
              </Typography>
            </Grid>
            <Grid item size={10}>
              <TextField
                fullWidth
                name="leaseperiod"
                size="small"
                value={state?.leaseperiod || ""}
                onChange={updateData}
                sx={inputStyle}
              />
            </Grid>

            <Grid item size={2}>
              <Typography variant="body1" sx={{ mt: 1.5 }}>
                Available From
              </Typography>
            </Grid>
            <Grid item size={10}>
              <TextField
                fullWidth
                name="availableFrom"
                size="small"
                value={state?.availableFrom || ""}
                onChange={updateData}
                sx={inputStyle}
              />
            </Grid>

            <Grid item size={2}>
              <Typography variant="body1" sx={{ mt: 1.5 }}>
                Available From Date
              </Typography>
            </Grid>
            <Grid item size={10}>
              <TextField
                fullWidth
                type="date"
                name="availableFromDate"
                size="small"
                InputLabelProps={{ shrink: true }}
                value={state?.availableFromDate || ""}
                onChange={updateData}
                sx={inputStyle}
              />
            </Grid>

            <Grid item size={2}>
              <Typography variant="body1" sx={{ mt: 1.5 }}>
                Deposit
              </Typography>
            </Grid>
            <Grid item size={10}>
              <TextField
                fullWidth
                name="deposit"
                size="small"
                value={state?.deposit || ""}
                onChange={updateData}
                sx={inputStyle}
              />
            </Grid>

            <Grid item size={2}>
              <Typography variant="body1" sx={{ mt: 1.5 }}>
                Annual Escalation
              </Typography>
            </Grid>
            <Grid item size={10}>
              <TextField
                fullWidth
                name="annualEscalation"
                size="small"
                value={state?.annualEscalation || ""}
                onChange={updateData}
                sx={inputStyle}
              />
            </Grid>

            <Grid item size={2}>
              <Typography variant="body1" sx={{ mt: 1.5 }}>
                Annual Escalation%
              </Typography>
            </Grid>
            <Grid item size={10}>
              <TextField
                fullWidth
                name="annualScalation"
                size="small"
                value={state?.annualScalation || ""}
                onChange={updateData}
                sx={inputStyle}
              />
            </Grid>

            <Grid item size={2}>
              <Typography variant="body1" sx={{ mt: 1.5 }}>
                Lease Includes
              </Typography>
            </Grid>
            <Grid item size={10}>
              <TextField
                fullWidth
                name="leaseIncludes"
                size="small"
                value={state?.leaseIncludes || ""}
                onChange={updateData}
                sx={inputStyle}
              />
            </Grid>

            <Grid item size={2}>
              <Typography variant="body1" sx={{ mt: 1.5 }}>
                Lease Excludes
              </Typography>
            </Grid>
            <Grid item size={10}>
              <TextField
                fullWidth
                name="leaseExcludes"
                size="small"
                value={state?.leaseExcludes || ""}
                onChange={updateData}
                sx={inputStyle}
              />
            </Grid>

            <Grid item size={2}>
              <Typography variant="body1" sx={{ mt: 1.5 }}>
                Lease Notes
              </Typography>
            </Grid>
            <Grid item size={10}>
              <TextField
                fullWidth
                name="leaseNotes"
                size="small"
                value={state?.leaseNotes || ""}
                onChange={updateData}
                sx={inputStyle}
              />
            </Grid>
          </Grid>
        </Collapse> */}

        {/* Offers Toggle */}
        {/* <Grid item size={10}>
          <Button variant="contained" color="primary" onClick={toggle} sx={{ mb: 2 }}>
            {isOpen ? "Hide Offers Details" : "Show Offers Details"}
          </Button>
          <Divider sx={{ borderColor: "#003366", mb: 2 }} />
          <Paper elevation={0} sx={{ p: 2, mb: 2 }}>
            <Typography variant="body1">
              Complete the fields if there is an offer
            </Typography>
          </Paper>
          <Divider sx={{ borderColor: "#003366", mb: 2 }} />
        </Grid>

        <Collapse in={isOpen} timeout="auto" unmountOnExit sx={{ width: "100%" }}>
          <Grid container spacing={2}>
            <Grid item size={2}>
              <Typography variant="body1" sx={{ mt: 1.5 }}>
                Enable Offers
              </Typography>
            </Grid>
            <Grid item size={10}>
              <RadioGroup
                row
                name="enableOffers"
                value={state?.enableOffers || ""}
                onChange={handleRadioChange}
              >
                <FormControlLabel value="YES" control={<Radio />} label="YES" />
                <FormControlLabel value="NO" control={<Radio />} label="NO" />
              </RadioGroup>
            </Grid>

            <Grid item size={2}>
              <Typography variant="body1" sx={{ mt: 1.5 }}>
                Offers
              </Typography>
            </Grid>
            <Grid item size={10}>
              <RadioGroup
                row
                name="offers"
                value={state?.offers || ""}
                onChange={handleRadioChange}
              >
                <FormControlLabel value="YES" control={<Radio />} label="YES" />
                <FormControlLabel value="NO" control={<Radio />} label="NO" />
              </RadioGroup>
            </Grid>

            <Grid item size={2}>
              <Typography variant="body1" sx={{ mt: 1.5 }}>
                Offer Status
              </Typography>
            </Grid>
            <Grid item size={10}>
              <TextField
                fullWidth
                name="offerStatus"
                size="small"
                value={state?.offerStatus || ""}
                onChange={updateData}
                sx={inputStyle}
              />
            </Grid>

            <Grid item size={2}>
              <Typography variant="body1" sx={{ mt: 1.5 }}>
                Offers From
              </Typography>
            </Grid>
            <Grid item size={10}>
              <TextField
                fullWidth
                name="oiffersFrom"
                size="small"
                value={state?.oiffersFrom || ""}
                onChange={updateData}
                sx={inputStyle}
              />
            </Grid>

            <Grid item size={2}>
              <Typography variant="body1" sx={{ mt: 1.5 }}>
                Offers Increment
              </Typography>
            </Grid>
            <Grid item size={10}>
              <TextField
                fullWidth
                name="offersIncrement"
                size="small"
                value={state?.offersIncrement || ""}
                onChange={updateData}
                sx={inputStyle}
              />
            </Grid>
          </Grid>
        </Collapse> */}
      </Grid>
    </Paper>
  );
});

export default BackOfficeStep;